import axios from 'axios';

export const workflowContainerApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-container`,
    headers: {
        'Content-Type': 'application/json'
    }
})